import * as React from 'react';

const CrossIcon = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12}>
    <path
      fill={fillColor}
      d="M6 6.875 1.625 11.25a.6.6 0 0 1-.438.188.6.6 0 0 1-.437-.188.6.6 0 0 1-.188-.438.6.6 0 0 1 .188-.437L5.125 6 .75 1.625a.6.6 0 0 1-.188-.438A.6.6 0 0 1 .75.75a.6.6 0 0 1 .438-.188.6.6 0 0 1 .437.188L6 5.125 10.375.75a.6.6 0 0 1 .438-.188.6.6 0 0 1 .437.188.6.6 0 0 1 .188.438.6.6 0 0 1-.188.437L6.875 6l4.375 4.375a.6.6 0 0 1 .188.438.6.6 0 0 1-.188.437.6.6 0 0 1-.438.188.6.6 0 0 1-.437-.188L6 6.875Z"
    />
  </svg>
);
export default CrossIcon;
